import React, { useEffect } from 'react';
import { getCurrentLanguage, getText, } from '@storebrand-digital/fms-translations';
import Button from '@storeblocks/button';
import { useModalContext } from '../../../../components/Context';
import { ButtonWrap } from '../styled';
import { ButtonWrapper } from './styled';
import Markdown from '../../../../components/Markdown';
function NavigationTip(_a) {
    var navTip = _a.navTip, label = _a.label, trackId = _a.trackId, onBackClick = _a.onBackClick;
    var language = getCurrentLanguage();
    var _b = useModalContext(), setHeading = _b.setHeading, setFooter = _b.setFooter;
    var lang = language === 'nb' ? 'no' : language;
    useEffect(function () {
        var buttonLabel = navTip.button.description[lang];
        setHeading(label);
        setFooter(React.createElement(ButtonWrapper, null,
            React.createElement(ButtonWrap, null,
                React.createElement(Button, { as: "a", href: navTip.button.link, "data-trackid": "button-".concat(trackId, "_back"), variant: "contained" }, buttonLabel),
                onBackClick !== undefined && (React.createElement(Button, { onClick: onBackClick, variant: "outlined", "data-trackid": "button-".concat(trackId, "_back") }, getText('compose.tip.back.label'))))));
    }, [setFooter, getText]);
    return React.createElement(Markdown, { text: navTip.description[lang] });
}
export default NavigationTip;
